module.exports = __webpack_public_path__ + "img/strategy.7e36b0c4.png";